// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: channel_message/channel_event.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ChannelActivityConfirmationTime } from "../channel/channel_activity_confirmation_time";
import { ChannelManagementEvent } from "../channel/channel_management_event";
import { ChannelProducePermissions } from "../channel/channel_produce_permissions";
import { ChannelState } from "../channel/channel_state";
import { ChannelStateShort } from "../channel/channel_state_short";
import { Peer } from "../peer/peer";

export const protobufPackage = "channel_message";

export enum ChannelEventType {
  CHANNEL_EVENT_TYPE_UNSPECIFIED = 0,
  /**
   * CHANNEL_EVENT_TYPE_CHANNEL_STATE - Event is sent as asynchronous response for `channel.triggerStateEvent` request.
   * Event payload will contain full information about all session peers.
   * Event is bound to request by corresponding `messageId` value.
   */
  CHANNEL_EVENT_TYPE_CHANNEL_STATE = 1,
  /**
   * CHANNEL_EVENT_TYPE_CHANNEL_STATE_SHORT - Event is sent periodically every N seconds and contains short information about all session peers.
   * Short state allows to check state consistency between client and media server,
   * and is not intended for state synchronization.
   */
  CHANNEL_EVENT_TYPE_CHANNEL_STATE_SHORT = 2,
  /**
   * CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_REQUIRED - This event is sent by media server as a request to check if channel still has any alive clients.
   * Event contains timeout value, after which channel will be considered inactive and server will
   * drop (disconnect) all hunging clients.
   * Clients should confirm user's activity to server according to it's internal logic (e.g. wait for user click a button).
   */
  CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_REQUIRED = 3,
  /**
   * CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_EXPIRED - This event is sent by server after activity timeout is expired. After this event
   * all clients should leave channel (or they will be disconnected from server side).
   * Clients should not reconnect without user action to the channel after this event.
   */
  CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_EXPIRED = 4,
  /**
   * CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_ACQUIRED - This event is sent by server as a confirmation that channel still has some alive clients.
   * After having this event, client does not longer need to confirm user activity or send confirmation to server.
   */
  CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_ACQUIRED = 5,
  /**
   * CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_CHANGED - This event is sent each time server or moderator changes produce permissions for a whole channel group.
   * Event contains up-to-date set of allowed produce permissions and list of permissions that were
   * changed since previous state.
   * For example, if permissions were changed from `[microphone, camera]` to `[microphone, screen-video]`.
   *   * producePermissions: `[microphone, screen-video]`
   *   * changedProducePermissions: `[camera, screen-video]`
   */
  CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_CHANGED = 6,
  /**
   * CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_DELETED - This event is sent each time server or moderator changes produce permissions for a whole channel group.
   * Event contains list of produce permissions that were removed since previous state.
   * For example, if permissions were changed from `[microphone, camera]` to `[microphone]`.
   *   * producePermissions: `[camera]`
   */
  CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_DELETED = 7,
  /**
   * CHANNEL_EVENT_TYPE_CHANNEL_MANAGEMENT_EVENT - / This event can be used as a transport for application-specific events.
   * / Client SDK should not interpret this kind of events and should pass event payload to the app level as-is.
   */
  CHANNEL_EVENT_TYPE_CHANNEL_MANAGEMENT_EVENT = 8,
  /** CHANNEL_EVENT_TYPE_PEER_JOINED - This event is sent when a new peer joins the channel. Contains full peer state. */
  CHANNEL_EVENT_TYPE_PEER_JOINED = 14,
  /**
   * CHANNEL_EVENT_TYPE_PEER_LEFT - This event is sent when a peer leaves channel (disconnects).
   * Peer that has left channel never comes back.
   * In case of a reconnect, he will be considered a new peer.
   */
  CHANNEL_EVENT_TYPE_PEER_LEFT = 15,
  /**
   * CHANNEL_EVENT_TYPE_PEER_PRODUCE_PERMISSIONS_CHANGED - This event is sent each time server or moderator changes someone's produce permissions.
   * Event contains up-to-date set of allowed produce permissions for given peer.
   */
  CHANNEL_EVENT_TYPE_PEER_PRODUCE_PERMISSIONS_CHANGED = 16,
  /**
   * CHANNEL_EVENT_TYPE_PEER_APP_DATA_CHANGED - This event is sent each time peer's AppData is changed by peer himsef, by moderator or by server.
   * Contains full up-to-date AppData for given peer.
   */
  CHANNEL_EVENT_TYPE_PEER_APP_DATA_CHANGED = 17,
  /** CHANNEL_EVENT_TYPE_PEER_GROUP_CHANGED - This event sets new channel groups assignment for given peer. */
  CHANNEL_EVENT_TYPE_PEER_GROUP_CHANGED = 18,
  UNRECOGNIZED = -1,
}

export function channelEventTypeFromJSON(object: any): ChannelEventType {
  switch (object) {
    case 0:
    case "CHANNEL_EVENT_TYPE_UNSPECIFIED":
      return ChannelEventType.CHANNEL_EVENT_TYPE_UNSPECIFIED;
    case 1:
    case "CHANNEL_EVENT_TYPE_CHANNEL_STATE":
      return ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_STATE;
    case 2:
    case "CHANNEL_EVENT_TYPE_CHANNEL_STATE_SHORT":
      return ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_STATE_SHORT;
    case 3:
    case "CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_REQUIRED":
      return ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_REQUIRED;
    case 4:
    case "CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_EXPIRED":
      return ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_EXPIRED;
    case 5:
    case "CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_ACQUIRED":
      return ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_ACQUIRED;
    case 6:
    case "CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_CHANGED":
      return ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_CHANGED;
    case 7:
    case "CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_DELETED":
      return ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_DELETED;
    case 8:
    case "CHANNEL_EVENT_TYPE_CHANNEL_MANAGEMENT_EVENT":
      return ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_MANAGEMENT_EVENT;
    case 14:
    case "CHANNEL_EVENT_TYPE_PEER_JOINED":
      return ChannelEventType.CHANNEL_EVENT_TYPE_PEER_JOINED;
    case 15:
    case "CHANNEL_EVENT_TYPE_PEER_LEFT":
      return ChannelEventType.CHANNEL_EVENT_TYPE_PEER_LEFT;
    case 16:
    case "CHANNEL_EVENT_TYPE_PEER_PRODUCE_PERMISSIONS_CHANGED":
      return ChannelEventType.CHANNEL_EVENT_TYPE_PEER_PRODUCE_PERMISSIONS_CHANGED;
    case 17:
    case "CHANNEL_EVENT_TYPE_PEER_APP_DATA_CHANGED":
      return ChannelEventType.CHANNEL_EVENT_TYPE_PEER_APP_DATA_CHANGED;
    case 18:
    case "CHANNEL_EVENT_TYPE_PEER_GROUP_CHANGED":
      return ChannelEventType.CHANNEL_EVENT_TYPE_PEER_GROUP_CHANGED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChannelEventType.UNRECOGNIZED;
  }
}

export function channelEventTypeToJSON(object: ChannelEventType): string {
  switch (object) {
    case ChannelEventType.CHANNEL_EVENT_TYPE_UNSPECIFIED:
      return "CHANNEL_EVENT_TYPE_UNSPECIFIED";
    case ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_STATE:
      return "CHANNEL_EVENT_TYPE_CHANNEL_STATE";
    case ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_STATE_SHORT:
      return "CHANNEL_EVENT_TYPE_CHANNEL_STATE_SHORT";
    case ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_REQUIRED:
      return "CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_REQUIRED";
    case ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_EXPIRED:
      return "CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_EXPIRED";
    case ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_ACQUIRED:
      return "CHANNEL_EVENT_TYPE_CHANNEL_ACTIVITY_CONFIRMATION_ACQUIRED";
    case ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_CHANGED:
      return "CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_CHANGED";
    case ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_DELETED:
      return "CHANNEL_EVENT_TYPE_CHANNEL_PRODUCE_PERMISSIONS_DELETED";
    case ChannelEventType.CHANNEL_EVENT_TYPE_CHANNEL_MANAGEMENT_EVENT:
      return "CHANNEL_EVENT_TYPE_CHANNEL_MANAGEMENT_EVENT";
    case ChannelEventType.CHANNEL_EVENT_TYPE_PEER_JOINED:
      return "CHANNEL_EVENT_TYPE_PEER_JOINED";
    case ChannelEventType.CHANNEL_EVENT_TYPE_PEER_LEFT:
      return "CHANNEL_EVENT_TYPE_PEER_LEFT";
    case ChannelEventType.CHANNEL_EVENT_TYPE_PEER_PRODUCE_PERMISSIONS_CHANGED:
      return "CHANNEL_EVENT_TYPE_PEER_PRODUCE_PERMISSIONS_CHANGED";
    case ChannelEventType.CHANNEL_EVENT_TYPE_PEER_APP_DATA_CHANGED:
      return "CHANNEL_EVENT_TYPE_PEER_APP_DATA_CHANGED";
    case ChannelEventType.CHANNEL_EVENT_TYPE_PEER_GROUP_CHANGED:
      return "CHANNEL_EVENT_TYPE_PEER_GROUP_CHANGED";
    case ChannelEventType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ChannelEvent {
  eventType: ChannelEventType;
  channelState?: ChannelState | undefined;
  channelStateShort?: ChannelStateShort | undefined;
  channelActivityConfirmationTime?: ChannelActivityConfirmationTime | undefined;
  channelManagementEvent?: ChannelManagementEvent | undefined;
  channelProducePermissions?: ChannelProducePermissions | undefined;
  peer?: Peer | undefined;
}

function createBaseChannelEvent(): ChannelEvent {
  return {
    eventType: 0,
    channelState: undefined,
    channelStateShort: undefined,
    channelActivityConfirmationTime: undefined,
    channelManagementEvent: undefined,
    channelProducePermissions: undefined,
    peer: undefined,
  };
}

export const ChannelEvent: MessageFns<ChannelEvent> = {
  encode(message: ChannelEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.eventType !== 0) {
      writer.uint32(8).int32(message.eventType);
    }
    if (message.channelState !== undefined) {
      ChannelState.encode(message.channelState, writer.uint32(18).fork()).join();
    }
    if (message.channelStateShort !== undefined) {
      ChannelStateShort.encode(message.channelStateShort, writer.uint32(26).fork()).join();
    }
    if (message.channelActivityConfirmationTime !== undefined) {
      ChannelActivityConfirmationTime.encode(message.channelActivityConfirmationTime, writer.uint32(34).fork()).join();
    }
    if (message.channelManagementEvent !== undefined) {
      ChannelManagementEvent.encode(message.channelManagementEvent, writer.uint32(42).fork()).join();
    }
    if (message.channelProducePermissions !== undefined) {
      ChannelProducePermissions.encode(message.channelProducePermissions, writer.uint32(50).fork()).join();
    }
    if (message.peer !== undefined) {
      Peer.encode(message.peer, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChannelEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChannelEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.eventType = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.channelState = ChannelState.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.channelStateShort = ChannelStateShort.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.channelActivityConfirmationTime = ChannelActivityConfirmationTime.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.channelManagementEvent = ChannelManagementEvent.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.channelProducePermissions = ChannelProducePermissions.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.peer = Peer.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChannelEvent {
    return {
      eventType: isSet(object.eventType) ? channelEventTypeFromJSON(object.eventType) : 0,
      channelState: isSet(object.channelState) ? ChannelState.fromJSON(object.channelState) : undefined,
      channelStateShort: isSet(object.channelStateShort)
        ? ChannelStateShort.fromJSON(object.channelStateShort)
        : undefined,
      channelActivityConfirmationTime: isSet(object.channelActivityConfirmationTime)
        ? ChannelActivityConfirmationTime.fromJSON(object.channelActivityConfirmationTime)
        : undefined,
      channelManagementEvent: isSet(object.channelManagementEvent)
        ? ChannelManagementEvent.fromJSON(object.channelManagementEvent)
        : undefined,
      channelProducePermissions: isSet(object.channelProducePermissions)
        ? ChannelProducePermissions.fromJSON(object.channelProducePermissions)
        : undefined,
      peer: isSet(object.peer) ? Peer.fromJSON(object.peer) : undefined,
    };
  },

  toJSON(message: ChannelEvent): unknown {
    const obj: any = {};
    if (message.eventType !== 0) {
      obj.eventType = channelEventTypeToJSON(message.eventType);
    }
    if (message.channelState !== undefined) {
      obj.channelState = ChannelState.toJSON(message.channelState);
    }
    if (message.channelStateShort !== undefined) {
      obj.channelStateShort = ChannelStateShort.toJSON(message.channelStateShort);
    }
    if (message.channelActivityConfirmationTime !== undefined) {
      obj.channelActivityConfirmationTime = ChannelActivityConfirmationTime.toJSON(
        message.channelActivityConfirmationTime,
      );
    }
    if (message.channelManagementEvent !== undefined) {
      obj.channelManagementEvent = ChannelManagementEvent.toJSON(message.channelManagementEvent);
    }
    if (message.channelProducePermissions !== undefined) {
      obj.channelProducePermissions = ChannelProducePermissions.toJSON(message.channelProducePermissions);
    }
    if (message.peer !== undefined) {
      obj.peer = Peer.toJSON(message.peer);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChannelEvent>, I>>(base?: I): ChannelEvent {
    return ChannelEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChannelEvent>, I>>(object: I): ChannelEvent {
    const message = createBaseChannelEvent();
    message.eventType = object.eventType ?? 0;
    message.channelState = (object.channelState !== undefined && object.channelState !== null)
      ? ChannelState.fromPartial(object.channelState)
      : undefined;
    message.channelStateShort = (object.channelStateShort !== undefined && object.channelStateShort !== null)
      ? ChannelStateShort.fromPartial(object.channelStateShort)
      : undefined;
    message.channelActivityConfirmationTime =
      (object.channelActivityConfirmationTime !== undefined && object.channelActivityConfirmationTime !== null)
        ? ChannelActivityConfirmationTime.fromPartial(object.channelActivityConfirmationTime)
        : undefined;
    message.channelManagementEvent =
      (object.channelManagementEvent !== undefined && object.channelManagementEvent !== null)
        ? ChannelManagementEvent.fromPartial(object.channelManagementEvent)
        : undefined;
    message.channelProducePermissions =
      (object.channelProducePermissions !== undefined && object.channelProducePermissions !== null)
        ? ChannelProducePermissions.fromPartial(object.channelProducePermissions)
        : undefined;
    message.peer = (object.peer !== undefined && object.peer !== null) ? Peer.fromPartial(object.peer) : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
